export default "__VITE_ASSET__CY0M3z5J__"